import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import AdditionalFieldsModal from 'zComponents/molecules/AdditionalFieldsModal';
import { Button, Col, Row, Tooltip } from 'zui/Antd';

const AdditionalInformationPanelExtra = ({ deviceID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canUpdateDevice = useManagePermittedRoles('updateDevice');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	// States
	const [openModal, setOpenModal] = useState(false);

	// Store
	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canUpdateDevice) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('additionalInformation')) {
			setActiveKeys([...activeKeys, 'additionalInformation']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('additionalInformation')) {
					return [...prev, 'additionalInformation'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canUpdateDevice ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canUpdateDevice}
						/>
					</span>
				</Tooltip>
			</Col>
			<AdditionalFieldsModal visible={openModal} setVisible={handleCloseModal} deviceID={deviceID}>
				<div />
			</AdditionalFieldsModal>
		</Row>
	);
};

export default AdditionalInformationPanelExtra;
